(() => {
  'use strict';

  function initialiseHeaderNavigation(scope = document) {
    const disclosures = [...scope.querySelectorAll('[data-rv-nav-disclosure]')];

    const setExpandedState = (details) => {
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', String(details.open));
    };

    disclosures.forEach((details) => {
      if (details.dataset.rvHeaderNavigationReady === 'true') return;

      const summary = details.querySelector(':scope > summary');

      summary?.addEventListener('click', () => {
        // The native `toggle` event is asynchronous. Reflect the next state at
        // activation time so assistive technology never observes stale state.
        summary.setAttribute('aria-expanded', String(!details.open));
      });

      details.addEventListener('toggle', () => {
        setExpandedState(details);
        if (!details.open) return;

        const navigation = details.closest('nav');
        navigation?.querySelectorAll('[data-rv-nav-disclosure][open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });

      details.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) details.open = false;
      });

      details.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape' || !details.open) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          details.open = false;
          setExpandedState(details);
          details.querySelector(':scope > summary')?.focus();
        },
        true
      );

      setExpandedState(details);
      details.dataset.rvHeaderNavigationReady = 'true';
    });
  }

  initialiseHeaderNavigation();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseHeaderNavigation(event.target);
  });
})();
